import { useMutation } from '../lib/use_mutation_hook';
import { useCheckoutDisplay } from './checkout_display_context';
import { MutationFn } from 'react-apollo';
import {
  CoreCheckoutSelectCreditCard,
} from '../schemas/rql';
import gql from 'graphql-tag';
import React from 'react';

export type SelectCheckoutCreditCardMutationFn = MutationFn<CoreCheckoutSelectCreditCard.Mutation, CoreCheckoutSelectCreditCard.Variables>;

export function useSelectCheckoutCreditCard(
  checkoutId: string,
  selectCheckoutCreditCard: SelectCheckoutCreditCardMutationFn,
) {
  const [mutate, { loading, errors }] = useMutation(selectCheckoutCreditCard);
  const { layoutQueryName } = useCheckoutDisplay();

  const selectCheckoutCreditCardCallback = React.useCallback(async ({ creditCardId }) => {
    return mutate({
      variables: {
        input: {
          id: checkoutId,
          creditCardId,
        },
      },
      refetchQueries: [layoutQueryName],
      awaitRefetchQueries: true,
    });
  }, [checkoutId, layoutQueryName, mutate]);

  return { selectCheckoutCreditCard: selectCheckoutCreditCardCallback, loading, errors };
}

export const CHECKOUT_SELECT_CREDIT_CARD_MUTATION = gql`
  mutation Core_Checkout_SelectCreditCard(
    $input: Input_core_apimessages_SelectCheckoutCreditCardRequest
  ) {
    selectCheckoutCreditCard(input: $input) {
      checkout {
        _id
      }
    }
  }
`;
